import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { NavMenu } from '../NavMenu';
import NotificationContainer from '../NotificationContainer';
import StatusBar from '../StatusBar';
import UIContext from '../../contexts/ui/UIContext';
import NotificationBanner from '../ui-elements/NotificationBanner';


const Layout = (props) => {

      const location = useLocation();
  const { banners, removeBanner } = useContext(UIContext);


  const isContainerManagementDisplayed = location.pathname === '/container';
      // const isContainerManagementDisplayed = false;
  // const readyToWork = false;
  // const areProcessesDisplayed = false;

  // console.log("Should not be center if any of the next 2is true:");
  // console.log("ProcessDisplay", areProcessesDisplayed);
  // console.log("ManagementDisplay", isContainerManagementDisplayed);
  // console.log("ReadyToWrokDisplay", readyToWork);
  const shouldNotBeCenterIf = [ isContainerManagementDisplayed ]
  const style = shouldNotBeCenterIf.some(condition => condition === true) ? { display: 'block' } : { display: 'flex', alignItems: 'baseline', justifyContent: 'center' }
  // Check if the used browser is safari
  const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;

  return (
    <div>
      <div>
        {banners.map(banner => (
          <NotificationBanner
            key={banner.id}
            text={banner.text}
            showCloseButton={true}
            onClose={() => removeBanner(banner.id)}
        />
        ))}
    </div>
    {isSafari ? (
      <div id='layout-container-safari'>
        <NotificationContainer />
          <NavMenu />
          <div id='layout-container-safari-body' style={style}>{props.children}</div>
          <StatusBar />
        </div>
      ) : (
        <div id='layout-container'>
          <NotificationContainer />
          <NavMenu />
          <div id='layout-container-body' style={style}>{props.children}</div>
          <StatusBar />
        </div>
      )
      }
      <div id="lailo-smart-character"></div>
    </div>
  );
};

export default Layout;
